module.exports = __webpack_public_path__ + "img/customer-service.0bc92c75.svg";